import { action as apiAction } from 'api/Api'

type Payload = {
  id: number
}

export default (payload: Payload) => async (_, getState) => {
  const { id } = payload

  const state = getState()

  const myBoardId = state.kanbo.currentUser.myBoardId

  return await apiAction('AddVCard', {
    vBoardId: myBoardId,
    cardId: id,
    position: 0
  })
}
